module.exports = __webpack_public_path__ + "static/media/165.1ae00e5d.jpg";